// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3i99q","emails":"CreateEditClinics_emails__2sa0m","emailTagLabel":"CreateEditClinics_emailTagLabel__2NVQQ"};